// src/admindashboardutils/components/CallStatisticsPie.jsx
import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const CallStatisticsPie = ({ pieData }) => {
  const renderCustomLabel = ({ percent }) => `${(percent * 100).toFixed(1)}%`;

  // Ensure at least a small value if all are 0 to force rendering
  const adjustedPieData = pieData.map((entry) => ({
    ...entry,
    value: entry.value === 0 ? 0.01 : entry.value, // Small value to force display
  }));
  const hasData = pieData.some((entry) => entry.value > 0);
  return (
    <div className="bg-white relative z-10 rounded-lg p-2 shadow-md">
      <h3 className="text-lg font-medium text-gray-700 mb-2 my-2">Call Statistics</h3>
      <div className="flex justify-center my-2 relative z-10">
      {hasData ? (
        <PieChart width={390} height={270}>
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={90}
            label={renderCustomLabel}
            labelLine={true}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>

) : (
    <PieChart width={370} height={250}>
      <Pie
        data={adjustedPieData}
        dataKey="value"
        nameKey="name"
        cx="50%"
        cy="50%"
        outerRadius={100}
        label={() => "0%"} // Force 0% label
        labelLine={true}
      >
        {adjustedPieData.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
      <Tooltip formatter={() => "0"} /> {/* Show 0 in tooltip */}
    </PieChart>
  )}
      </div>
    </div>
  );
};

export default CallStatisticsPie;